import {IconColors, IconNames, IconSize} from '../../common/aur-icon/AurIcon';

export interface labelProps {
  status: string;
  icon?: (typeof IconNames)[keyof typeof IconNames];
  fontColor?: string;
  iconColor?: (typeof IconColors)[keyof typeof IconColors];
  iconSize?: IconSize;
}

export const initailLabelDetails: labelProps[] = [
  {
    status: 'Active',
    icon: IconNames.Circle,
    iconColor: IconColors.Success,
    iconSize: 'small',
  },
  {
    status: 'Billable',
    icon: IconNames.CurrencyUSD,
    iconColor: IconColors.Success,
    iconSize: 'small',
  },
  {
    status: 'Limited IP Access',
    icon: IconNames.Security,
    iconColor: IconColors.Success,
    iconSize: 'small',
  },
];
